import { render } from "./Tabs.vue?vue&type=template&id=f410c924&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=f410c924&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f410c924"],['__file',"src/scripts/view/portfolio/sections/Tabs.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f410c924"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f410c924', __exports__)) {
    api.reload('f410c924', __exports__)
  }
  
  module.hot.accept("./Tabs.vue?vue&type=template&id=f410c924&scoped=true", () => {
    api.rerender('f410c924', render)
  })

}


export default __exports__